import React, { useContext, useEffect, useState } from "react";
import AppContext from "../../context/AppContext";
import { toast } from "react-toastify";
import {taskHistoryDetails, taskHistoryDetailsByDept, taskHistoryDetailsByOrg} from "../../service/Task";
import Cookies from "js-cookie";
import ImportModal from "./ImportModal";
import { CgExport } from "react-icons/cg";
import { Spinner } from "../../Spinner";
import translations from "../../components/common/Translations";
import { IoDownloadOutline } from "react-icons/io5";
import CommonButton from "../../components/common/CommonButton";
import moment from "moment";

const TaskHistory = () => {
  const [accountNumber, setAccountNumber] = useState("");
  const [accountDetails, setaccountDetails] = useState({});
  const [accountHistory, setAccountHistory] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const context = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const { langMode, theme, projectId } = context;
  const [open, setOpen] = useState(false);
  const accountNumberFetch = (e) => {
    setAccountNumber(e.target.value);
  };

  const handleChange = (e) => {
    console.log(e.target.value);
  };

  const clearData = () => {
    setAccountNumber("");
    setaccountDetails({});
    setAccountHistory([]);
  };

  const fetchTaskHistory = async () => {
    setIsLoading(true);
    try {

      // console.log("Department Id: ", deptId)
      const responseData = await taskHistoryDetailsByDept(
        accountNumber,
        projectId
      );
      if (responseData?.header?.code === 600) {
        const accountDetails =
          responseData.body.value.accountDetails || {};
        // setaccountDetails(accountDetails);

        setaccountDetails(accountDetails); // Set the entire object

        setAccountHistory(responseData.body.value.accountHistory);
        toast.success("Data fetched successfully");
      } else {
        toast.error(responseData.body.value);
      }
    } catch (error) {
      console.error("Error fetching task history:", error);
      toast.error("An error occurred while fetching the task history");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    console.log(accountHistory);
  }, [accountHistory]);

  const handlImportModal = () => {
    setOpen(true);
  };

  const handleExportClick = (pdfLink) => {
    if (pdfLink) {
      const width = 800; // Width of the popup
      const height = 600; // Height of the popup

      // Calculate the top and left positions to center the popup
      const left = window.screen.width / 2 - width / 2;
      const top = window.screen.height / 2 - height / 2;

      // Open the popup window
      window.open(
        pdfLink,
        "_blank",
        `width=${width},height=${height},top=${top},left=${left},scrollbars=yes,resizable=yes`
      );
    } else {
      console.error("PDF link is not provided.");
    }
  };

  return (
    <div className="w-full py-1">
      <h4
        className={`uppercase ml-[10px] font-semibold whitespace-nowrap text-gray-800 ${
          theme === "dark"
            ? "dark-mode "
            : theme === "high-contrast"
            ? "high-contrast  "
            : ""
        }`}
      >
        {translations[langMode].taskhistory}
      </h4>
      <div
        className={`bg-white px-5 rounded-md py-4 ${
          theme === "dark"
            ? "dark-mode"
            : theme === "high-contrast"
            ? "high-contrast"
            : ""
        }`}
      >
        <div className="px-4 sm:px-0 flex xsm:flex-row flex-col justify-between gap-y-3">
          <h3
            className={`${langMode === "ar" ? 'text-lg' : "text-sm font-semibold text-gray-900"}   ${
              theme === "dark"
                ? "dark-mode "
                : theme === "high-contrast"
                ? "high-contrast  "
                : ""
            }`}
          >
            {translations[langMode].acchistory}
          </h3>
          {/* <button
            className="px-2 py-2 gap-3 mr-14 inline-flex text-sm rounded-md bg-blue-800 text-white font-medium hover:bg-blue-700 transition-colors  items-center"
            onClick={handlImportModal}
          >
            <CgExport size={20} />
            {translations[langMode].importdb}
          </button> */}

          <CommonButton onClick={handlImportModal} variant="success">
            <CgExport size={20} />
            {translations[langMode].importdb}
          </CommonButton>
        </div>
        <div className="flex flex-col py-1 overflow-y-auto w-full">
          <div className="p-4 xl:w-1/4 lg:w-1/3 md:w-1/2 w-full">
            <label
              className={`${
                theme === "dark"
                  ? "dark-mode "
                  : theme === "high-contrast"
                  ? "high-contrast  "
                  : ""
              } text-gray-700 ${langMode === "ar" ? "text-lg" : "text-sm"} font-medium block mb-2`}
            >
              {translations[langMode].enteraccno}
            </label>
            <input
              type="text"
              className={` ${
                theme === "dark"
                  ? "dark-mode"
                  : theme === "high-contrast"
                  ? "high-contrast"
                  : ""
              } w-full px-3 py-2 text-sm rounded-md border border-gray-300 
              focus:ring-2 focus:ring-blue-500 focus:outline-none transition-shado`}
              onChange={accountNumberFetch}
              value={accountNumber}
              placeholder={translations[langMode].enteraccno}
            />
            <div className="flex justify-end py-2 gap-3">
              {/* <button
                className="px-2 py-2 text-sm rounded-md bg-yellow-400 text-white font-medium hover:bg-yellow-500 transition-colors"
                onClick={clearData}
              >
                {translations[langMode].reset}
              </button> */}

              <CommonButton onClick={clearData} variant="danger">
                {translations[langMode].reset}
              </CommonButton>

              {/* <button
                onClick={fetchTaskHistory}
                className="px-2 py-2  text-sm rounded-md bg-blue-800 text-white font-medium hover:bg-blue-700 transition-colors flex items-center"
              >
                {isLoading ? (
                  <svg
                    className="animate-spin h-5 w-5 text-white mr-2"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                    ></path>
                  </svg>
                ) : (
                  translations[langMode].submit
                )}
              </button> */}

              <CommonButton onClick={fetchTaskHistory} variant="primary">
                {isLoading ? (
                  <svg
                    className="animate-spin h-5 w-5 text-white mr-2"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                    ></path>
                  </svg>
                ) : (
                  translations[langMode].submit
                )}
              </CommonButton>
            </div>
          </div>
          <div
            className={`relative sm:rounded-lg py-2 bg-white shadow-lg  ${
              theme === "dark"
                ? "dark-mode"
                : theme === "high-contrast"
                ? "high-contrast"
                : ""
            }`}
          >
            <h2
              className={`${langMode === "ar" ? "text-lg" : "text-gray-800 dark:text-gray-100 text-sm font-semibold"} mb-4 ${
                theme === "dark"
                  ? "dark-mode "
                  : theme === "high-contrast"
                  ? "high-contrast  "
                  : ""
              }`}
            >
              {translations[langMode].accDetail}
            </h2>
            <div className="w-full overflow-x-auto">
              <table className="text-sm text-left text-gray-700 dark:text-gray-400 whitespace-nowrap">
                <thead
                  className={`   ${
                    theme === "dark"
                      ? "dark-mode"
                      : theme === "high-contrast"
                      ? "high-contrast"
                      : ""
                  } text-xs text-gray-700 uppercase border-b bg-gray-100 `}
                >
                  <tr>
                    {/* {Object.keys(accountDetails).map((key) => (
                      <th key={key} scope="col" className="px-6 py-3 text-nowrap">
                        {key}
                      </th>
                    ))} */}
                    {accountDetails?.accountDetailsJson &&
                    Object.keys(accountDetails?.accountDetailsJson).length > 0 ? <>
                     { Object.keys(accountDetails?.accountDetailsJson).map((key) => (
                        <th
                          key={key}
                          scope="col"
                          className="px-6 py-3 text-nowrap"
                        >
                          {key}
                        </th>
                      ))
                    }
                        {/* <th scope="col" className="px-6 py-3 text-nowrap">Current OS</th> */}
                        <th scope="col" className="px-6 py-3 text-nowrap">Current OS Updated At</th>
                        <th scope="col" className="px-6 py-3 text-nowrap">Current Outstanding</th>
                        <th scope="col" className="px-6 py-3 text-nowrap">Last Updated Date</th>
                        <th scope="col" className="px-6 py-3 text-nowrap">Last Updated Time</th>
                  </>
                    : (
                      <th colSpan="100%" className={`px-6 py-3 text-center ${langMode === "ar" ? "text-lg" : "text-sm"}`}>
                        {translations[langMode].noAccountDetialsAvailable}
                      </th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  <tr
                    className={`bg-white  border-b hover:bg-gray-50 ${
                      theme === "dark"
                        ? "dark-mode"
                        : theme === "high-contrast"
                        ? "high-contrast"
                        : ""
                    }`}
                  >
                    {accountDetails && accountDetails?.accountDetailsJson &&  Object.entries(accountDetails?.accountDetailsJson)?.map(([key, value]) => (
                      <td key={key} className="px-6 py-4">
                        {value !== undefined && value !== null && value !== ""  ? (
                          value
                        ) : (
                          <input
                            type="text"
                            name={key}
                            value={value}
                            onChange={handleChange}
                            className={`w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 ${
                              theme === "dark"
                                ? "dark-mode"
                                : theme === "high-contrast"
                                ? "high-contrast"
                                : ""
                            }`}
                            placeholder={`Enter ${key}`}
                          />
                        )}
                      </td>
                    ))}
                    {/* <td className="px-6 py-4">{accountDetails?.currentOs || "-"}</td> */}
                    <td className="px-6 py-4">{accountDetails?.currentOsUpdatedAt && moment(accountDetails?.currentOsUpdatedAt).format("DD-MM-YYYY HH:mm") || "-"}</td>
                    <td className="px-6 py-4">{accountDetails?.currentOutstanding || "-"}</td>
                    <td className="px-6 py-4">{accountDetails?.lastUpdatedDate || "-"}</td>
                    <td className="px-6 py-4">{accountDetails?.lastUpdatedTime && moment(accountDetails?.lastUpdatedTime, "HH:mm:ss").format("HH:mm")  || "-"}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          {isLoading ? (
            <Spinner />
          ) : (
            <div>
              {accountHistory.map((workflow, index) => (
                <div key={index} className="relative sm:rounded-lg py-7">
                  <h2
                    className={`${
                      theme === "dark"
                        ? "dark-mode"
                        : theme === "high-contrast"
                        ? "high-contrast"
                        : ""
                    } text-gray-800 text-md font-semibold`}
                  >
                    {workflow.workflowName} History
                  </h2>
                  <div className="overflow-x-auto">
                    <table className="w-full text-sm shadow-md text-left rtl:text-right text-gray-500 dark:text-gray-400 my-5">
                      <thead
                        className={`${
                          theme === "dark"
                            ? "dark-mode"
                            : theme === "high-contrast"
                            ? "high-contrast"
                            : ""
                        } text-xs text-gray-700 uppercase border-b bg-gray-100 `}
                      >
                        <tr>
                          {" "}
                          <th className="px-6 py-3">TaskId</th>
                          <th className="px-6 py-3">Assignee Name</th>
                          {/* <th className="px-6 py-3">Visit Date</th>
                          <th className="px-6 py-3">Visit Time</th> */}
                          <th className="px-6 py-3">finished Date</th>
                          <th className="px-6 py-3">Finished Time</th>
                          <th className="px-6 py-3">Created By</th>
                          <th className="px-6 py-3">Remarks</th>
                          <th>Download PDF</th>
                        </tr>
                      </thead>
                      <tbody>
                        {workflow.accountHistoryList.map((history, idx) => (
                          <tr
                            key={idx}
                            className={`bg-white  border-b dark:border-gray-700 ${
                              theme === "dark"
                                ? "dark-mode"
                                : theme === "high-contrast"
                                ? "high-contrast"
                                : ""
                            }`}
                          >
                            <th className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                              {history.taskId}
                            </th>
                            <td className="px-6 py-4">
                              {" "}
                              {history.assigneeName}
                            </td>
                            {/* <td className="px-6 py-4">{history.visitDate}</td> */}
                            {/* <td className="px-6 py-4">
                              {history.vistTime
                                ? new Date(
                                  `1970-01-01T${history.vistTime}`
                                ).toLocaleTimeString("en-US", {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                })
                                : "Invalid time"}
                            </td> */}
                            <td className="px-6 py-4">
                              {history.finishedDate}
                            </td>
                            <td className="px-6 py-4">
                              {history.finishedTime
                                ? new Date(
                                    `1970-01-01T${history.finishedTime}`
                                  ).toLocaleTimeString("en-US", {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                  })
                                : "Invalid time"}
                            </td>
                            <td className="px-6 py-4">
                              {history?.createdBy ?? "N/A"}
                            </td>
                            <td className="px-6 py-4">{history?.remarks}</td>
                            <td>
                              {history.pdfLink ? (
                                <button
                                  onClick={() =>
                                    handleExportClick(history.pdfLink)
                                  }
                                  className="py-2 px-2 rounded-md bg-yellow-400 hover:bg-yellow-500 text-white text-sm inline-flex gap-2"
                                >
                                  <IoDownloadOutline size={20} className="" />{" "}
                                  Download PDF
                                </button>
                              ) : (
                                <span className="text-gray-800">
                                  No PDF available
                                </span>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      <ImportModal
        open={open}
        setOpen={setOpen}
        loading={loading}
        setLoading={setLoading}
      />
      {loading && <Spinner />}
    </div>
  );
};
export default TaskHistory;
